import { ActivityToMapType } from "@/app/constants/configuration/activityToMapType"
import { BreaksMappingDestination } from "@/app/constants/configuration/breaksMappingDestination"
import { ShortBreakType } from "@/app/constants/configuration/shortBreakType"
import { LeaveBaseType } from "@/app/constants/configuration/leaveBaseType"
import { LumpSumAmountsCoveredOptions } from "@/app/constants/configuration/lumpSumAmountsCoveredOptions"
import { MappingActivityDestination } from "@/app/constants/configuration/mappingActivityDestination"
import { PpkTaxModeType } from "@/app/constants/configuration/ppkTaxModeType"
import { ShortBreakMode } from "@/app/constants/configuration/shortBreakMode"
import { SickLeaveBaseType } from "@/app/constants/configuration/sickLeaveBaseType"

import { TimesheetMinimalPeriodsSource } from "@/app/constants/configuration/timesheetMinimalPeriodsSource"

export const BREAK_MAPPING_DESTINATIONS: BreaksMappingDestination[] = [
  BreaksMappingDestination.Duty50,
  BreaksMappingDestination.Duty100,
  BreaksMappingDestination.Work,
]

export const SHORT_BRAKE_MODES: ShortBreakMode[] = [
  ShortBreakMode.BySchedule,
  ShortBreakMode.ByActivities,
]

export const SHORT_BREAK_TYPES: ShortBreakType[] = [
  ShortBreakType.DriversWorkingHours,
  ShortBreakType.LaborCode,
]

export const LUMPSUM_AMOUNTS_COVERED_OPTIONS: LumpSumAmountsCoveredOptions[] = [
  LumpSumAmountsCoveredOptions.Hide,
  LumpSumAmountsCoveredOptions.ShowCovered,
  LumpSumAmountsCoveredOptions.ShowSettlementOnLastMonth,
  LumpSumAmountsCoveredOptions.ShowSettlementOnNextPeriod,
  LumpSumAmountsCoveredOptions.ShowSettlementOnEveryMonth,
]

export const TIMESHEET_MINIMAL_PERIOD_SOURCES: TimesheetMinimalPeriodsSource[] = [
  TimesheetMinimalPeriodsSource.MixMode,
  TimesheetMinimalPeriodsSource.Trip,
  TimesheetMinimalPeriodsSource.Gps,
]

export const ACTIVITY_TO_MAP_TYPES: ActivityToMapType[] = [
  ActivityToMapType.Rest,
  ActivityToMapType.Availability,
  ActivityToMapType.AvailabilityInCrew,
  ActivityToMapType.Work,
]

export const MAPPING_ATIVITY_DESTINATIONS: MappingActivityDestination[] = [
  MappingActivityDestination.Driving,
  MappingActivityDestination.Availability,
  MappingActivityDestination.UnauthorizedBreaks,
  MappingActivityDestination.Duty50,
  MappingActivityDestination.Duty100,
  MappingActivityDestination.Rest,
]

export const LEAVE_BASE_TYPES: LeaveBaseType[] = [
  LeaveBaseType.FromContract,
  LeaveBaseType.FromContractWithDeductions,
]

export const SICK_LEAVE_BASE_TYPES: SickLeaveBaseType[] = [
  SickLeaveBaseType.GrossZus,
  SickLeaveBaseType.FromContract,
]

export const PPK_TASK_MODES: PpkTaxModeType[] = [
  PpkTaxModeType.CurrentMonth,
  PpkTaxModeType.NextMonth,
]

export const PLANNED_HOURS_ROUNDINGS: string[] = [
  '00:01:00',
  '00:15:00',
  '00:30:00',
  '01:00:00',
]

export const CALCULATION_ROUNDINGS: string[] = ['00:01:00', '00:15:00']
